import React from 'react';
import PropTypes from 'prop-types';
import postal from 'postal';

import Loading from '../../../../shared/loading';
import ErrorBoundary from '../../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import { updateIsCommercial } from '../../../../services/wire/edit-services';

export default class CommercialControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    wasCommercial: PropTypes.bool.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      isCommercial: this.props.wasCommercial,
    };
  }

  handleIsCommercialChange(evt) {
    const isCommercial = evt.target.value === 'true';

    this.loading.start();
    updateIsCommercial(this.props.wireId, isCommercial)
      .then(() => {
        this.setState({ isCommercial });
        postal.publish({
          channel: 'editor',
          topic: 'is-commercial-changed',
          data: isCommercial,
        });
      })
      .catch(e => defaultOnErrorHandler(e, 'Error updating is Commercial status'))
      .finally(() => this.loading.stop());
  }

  render() {
    return (
      <ErrorBoundary>
        <aside className="sidebar-item">
          <form className="--user-facing">
            <section className="form-group">
              <span className="sidebar-item-desc">Is this a commercial wire?</span>
              <label htmlFor="commercial-yes" className="sidebar-item-radio-group">
                <input
                  id="commercial-yes"
                  type="radio"
                  value
                  checked={this.state.isCommercial}
                  onChange={e => this.handleIsCommercialChange(e)}
                />
                Yes
              </label>
              <label htmlFor="commercial-no" className="sidebar-item-radio-group">
                <input
                  id="commercial-no"
                  type="radio"
                  value={false}
                  checked={!this.state.isCommercial}
                  onChange={e => this.handleIsCommercialChange(e)}
                />
                No
              </label>
              <Loading variant="sip" ref={el => (this.loading = el)} />
            </section>
          </form>
        </aside>
      </ErrorBoundary>
    );
  }
}
